import type { ReactNode } from 'react'
import '@ondit/tokens/loading.css'

/**
 * The seal, spinning, with a sentence under it, for a whole page with nothing
 * drawn yet. A region inside a frame that has already drawn takes a skeleton
 * shaped like its content instead.
 *
 * Geometry and motion live in `@ondit/tokens/loading.css`.
 */
export function BrandLoading({ children, label }: { children: ReactNode; label: string }) {
  return (
    <div className='brand-loading' role='status' aria-label={label} aria-atomic='true'>
      <span className='brand-loading-mark' aria-hidden='true'>
        {children}
      </span>
      <span className='brand-loading-label'>{label}</span>
    </div>
  )
}
